/**
 * Inbox route (OL-375) — eagerly registers `/orca/inbox` and re-applies its OWN
 * guard; the page component, its atoms and the frame are deferred to
 * `index.lazy.tsx` so nothing the Inbox renders lands in the always-loaded
 * chunk (`packages/web/budgets.json`, "Web Bundle Budgets"). The sheets that
 * chunk's markup depends on come from `head()` here instead, as `?url` links.
 *
 * `orcaloops.ai/inbox` rewrites onto this path — every orcaloops.ai path does,
 * because `/orca` is a WILDCARD domain prefix.
 *
 * **`requireAuth`, never `requireAdmin`** — the loops index's pattern exactly.
 * `/orca/inbox` is an `ORCA_PUBLIC_ROOTS` entry so the `/orca` layout guard
 * steps aside on the ADMIN check; this guard puts a session back in its place.
 * A person answering their own runs is not an operator. The session is
 * necessary but not sufficient: `loops.humanWaits.*` resolves the owning
 * customer from the actor, so a member only ever sees their own waits.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

import { loopShellStylesheetLinks } from "~/lib/loop-shell-head.ts";
import { requireAuth } from "~/lib/server-auth.ts";

/**
 * The guard, extracted so it is unit-testable without the route machinery.
 *
 * @since 1.0.0
 */
// oxlint-disable-next-line eslint-js/no-restricted-syntax -- TanStack redirects require async/await
export const inboxBeforeLoad = async () => {
  // oxlint-disable-next-line eslint-js/no-restricted-syntax -- TanStack redirects require async/await
  const auth = await requireAuth();
  return { auth };
};

/**
 * The route's `head()`: the orcaloops frame's sheet.
 * Extracted so it is unit-testable without the route machinery.
 *
 * @since 1.0.0
 */
export const inboxHead = () => ({ links: loopShellStylesheetLinks });

export const Route = createFileRoute("/orca/inbox/")({
  beforeLoad: inboxBeforeLoad,
  head: inboxHead,
});
